import { IconButton, Tooltip, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { SxProps } from "@mui/material/styles";
import { styled } from "@mui/system";
import { FC } from "react";
import { User } from "../../graphql/types";
import { getUserInitials, toLocalAndUtcDates } from "../../lib/Util";

const TooltipTitle = styled("div")({
  display: "flex",
  flexDirection: "column",
});

interface UserAvatarProps {
  name: string;
  size?: "small" | "medium";
}

export const UserAvatar: FC<UserAvatarProps> = ({ name, size = "small" }) => {
  return (
    <Avatar
      sx={(theme) => ({
        fontWeight: 500,
        bgcolor: theme.palette.primary50.main,
        width: size === "medium" ? "48px" : "24px",
        height: size === "medium" ? "48px" : "24px",
      })}
    >
      <Typography
        variant={size === "medium" ? "body.large.regular" : "body.xSmall.regular"}
        sx={{ color: "primary10.main" }}
      >
        {getUserInitials(name)}
      </Typography>
    </Avatar>
  );
};

interface IUserAvatarWithTooltip {
  user: Pick<User, "name" | "email">;
  prefix: string;
  userDate?: string;
  sxIconButton?: SxProps;
  size?: "small" | "medium";
}

export const UserAvatarWithTooltip: FC<IUserAvatarWithTooltip> = ({
  user,
  prefix,
  userDate = "",
  sxIconButton = { marginLeft: "10px", marginRight: "10px", padding: "0" },
  size,
}) => {
  const name = `${prefix}${user.name}`;
  const email = user.email;
  let date = "";
  if (userDate !== "") {
    const { browser, utc } = toLocalAndUtcDates(userDate);
    date = `${browser} [${utc}]`;
  }
  return (
    <Tooltip
      arrow
      title={
        <TooltipTitle>
          <Typography>{name}</Typography>
          <Typography>{email}</Typography>
          <Typography>{date}</Typography>
        </TooltipTitle>
      }
    >
      <IconButton sx={sxIconButton} data-cy="tooltip-container-user-avatar">
        <UserAvatar name={user.name} size={size} />
      </IconButton>
    </Tooltip>
  );
};
